import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import { TiptapVuetifyPlugin } from 'tiptap-vuetify';
import 'tiptap-vuetify/dist/main.css';

Vue.use(TiptapVuetifyPlugin, {
    vuetify,
    iconsGroup: 'mdi',
});
